var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"one-theme",style:({ 
        backgroundImage: ("url(" + _vm.imgLocal + ")"),
        backgroundPosition: 'center center', 
        backgroundSize: 'cover' 
    }),on:{"click":function($event){return _vm.clickOneTheme()}}},[_c('div',{staticClass:"one-theme__title"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }